// mt-gift-banner.js — inicializa y mantiene actualizado el banner de regalo
(function(){
  const CLS = 'mt-gift-banner';
  const INIT = 'data-mt-initialized';

  function money(n){
    try { return new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(n); }
    catch(e){ return '$'+Math.round(n).toLocaleString('es-CL'); }
  }

  async function readCartAndRender(banner){
    try{
      const r = await fetch('/cart.js', { headers:{'Accept':'application/json'}, cache:'no-store' });
      const c = await r.json();
      const totalPesos = Math.round((c.total_price||0)/100); // centavos -> pesos
      render(banner, totalPesos);
    }catch(e){}
  }

// === Movimiento visual de la barra ===
// Esta función hace que la textura se mueva en loop aunque el tema bloquee animaciones
function startStripeMotion(fillEl){
  if (!fillEl || fillEl.__mtMotionStarted) return;
  fillEl.__mtMotionStarted = true;

  const periodPx = 40; // igual que el tamaño de fondo en CSS
  const speedPxPerSec = 40; // velocidad del desplazamiento
  const speedPxPerMs = speedPxPerSec / 1000;

  let last = performance.now();
  let acc = 0;

  function frame(now){
    if (!document.body.contains(fillEl)) return; // si ya no existe, detenemos
    const dt = now - last; last = now;
    acc = (acc + dt * speedPxPerMs) % periodPx;
    fillEl.style.setProperty('--mt-shift', acc.toFixed(2) + 'px');
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}




 function render(banner, total){
  const giftTh = parseInt(banner.dataset.threshold||banner.dataset.giftThreshold||'40000',10);
  const giftLabel = banner.dataset.giftLabel || 'Regalo gratis';

  const shipTh = parseInt(banner.dataset.shipThreshold||'0',10);
  const shipLabel = banner.dataset.shipLabel || 'Envío gratis (Chile)';
  const shipCountry = (banner.dataset.shipCountry||'CL').toUpperCase();
  const customerCountry = (banner.dataset.customerCountry||'').toUpperCase();

  const textEl = banner.querySelector('.mt-gift-text');
  const fillEl = banner.querySelector('.mt-gift-bar__fill');


  // Inicia movimiento visual de la barra
startStripeMotion(fillEl);

  const pinEl  = banner.querySelector('.mt-gift-pin');
  const markGift = banner.querySelector('.mt-marker--gift');
  const markShip = banner.querySelector('.mt-marker--ship');
  if(!textEl || !fillEl) return;

  

  // Escala: usar el mayor umbral para la barra
  const maxTh = Math.max(giftTh, shipTh || giftTh);
  const p = Math.max(0, Math.min(1, total / maxTh));
  const pct = Math.round(p * 100);

  const barEl = banner.querySelector('.mt-gift-bar');
if (barEl) barEl.style.setProperty('--mtp', pct + '%');



// actualiza con variable (lo que usa el CSS)
fillEl.style.setProperty('--mtw', pct + '%');

// y también el width inline, por si algún CSS externo pisa la variable
fillEl.style.width = pct + '%';

  // Avance barra y pin
  fillEl.style.width = pct + '%';
  if(pinEl){
    const clampPct = Math.max(0, Math.min(100, pct));
    pinEl.style.left = `calc(${clampPct}% - 11px)`;
    pinEl.classList.toggle('at-start', clampPct <= 0);
    pinEl.classList.toggle('at-end', clampPct >= 100);
  }

  // Posición de marcadores
  if(markGift){
    const giftPct = Math.min(100, Math.round((giftTh / maxTh) * 100));
    markGift.style.left = giftPct + '%';
  }
  if(markShip && shipTh > 0){
    const shipPct = Math.min(100, Math.round((shipTh / maxTh) * 100));
    markShip.style.left = shipPct + '%';
  }

    // Elegibilidad de envío gratis (solo país permitido)
  const shipEligible = shipTh > 0 && customerCountry === shipCountry;
  banner.classList.toggle('not-eligible', !shipEligible);


  // ⬇️ PEGA AQUÍ
// Bandas al estilo Halo (30 / 60 / 100 / free) usando clases en el banner
banner.classList.remove('mt-p30','mt-p60','mt-p100','mt-pfree');
if (shipTh > 0 && total >= shipTh && shipEligible) {
  banner.classList.add('mt-pfree');
} else if (pct >= 100) {
  banner.classList.add('mt-p100');
} else if (pct >= 60) {
  banner.classList.add('mt-p60');
} else {
  banner.classList.add('mt-p30');
}

  // Marcar que los hitos ya tienen posición (para mostrar con CSS)
  banner.classList.add('ready');

  // ===== Mensajes claros según progreso =====
  if (total < giftTh) {
    const faltaGift = giftTh - total;
    const faltaShip = shipTh > 0 ? shipTh - total : 0;
    textEl.innerHTML =
      `🎁 Te falta <b>${money(faltaGift)}</b> para <b>${giftLabel}</b>.` +
      (shipTh > 0
        ? (shipEligible
            ? ` | 🚚 Te falta <b>${money(faltaShip)}</b> para <b>${shipLabel}</b>.`
            : ` | 🚚 ${shipLabel} a partir de <b>${money(shipTh)}</b> (solo Chile).`)
        : '');
    banner.classList.remove('is-gift','is-ship');

  } else if (total >= giftTh && (shipTh === 0 || total < shipTh)) {
    const faltaShip = shipTh > 0 ? shipTh - total : 0;
    textEl.innerHTML =
      `🎁 ¡<b>${giftLabel}</b> listo!` +
      (shipTh > 0
        ? (shipEligible
            ? ` | 🚚 Te falta <b>${money(faltaShip)}</b> para <b>${shipLabel}</b>.`
            : ` | 🚚 ${shipLabel} <b>solo en Chile</b> (umbral: ${money(shipTh)}).`)
        : '');
    banner.classList.add('is-gift'); banner.classList.remove('is-ship');

  } else {
    // total >= shipTh
    banner.classList.add('is-gift');
    if (shipTh > 0) {
      if (shipEligible) {
        banner.classList.add('is-ship');
        textEl.innerHTML = `🎁 ¡<b>${giftLabel}</b> desbloqueado! | 🚚 ¡<b>${shipLabel}</b> activado!`;
      } else {
        banner.classList.remove('is-ship');
        textEl.innerHTML = `🎁 ¡<b>${giftLabel}</b> desbloqueado! | 🚚 ${shipLabel} <b>solo en Chile</b>.`;
      }
    } else {
      textEl.innerHTML = `🎁 ¡<b>${giftLabel}</b> desbloqueado!`;
    }
  }

}


  function initOne(banner){
    if(!banner || banner.getAttribute(INIT)==='1') return;
    banner.setAttribute(INIT,'1');

    const deb=(fn,t)=>{let id;return()=>{clearTimeout(id);id=setTimeout(fn,t)}};
    const reread = deb(()=>readCartAndRender(banner),180);

    // Eventos típicos de cambios de carrito/section
    ['cart:updated','cart:change','change','click','submit','shopify:section:load','shopify:section:render','page:load']
      .forEach(ev=>document.addEventListener(ev, reread, true));

    // Refresco periódico mientras el drawer esté abierto (por si el tema no emite eventos)
    const drawer = document.querySelector('.cart-drawer');
    let interval = null;
    function loop(){
      clearInterval(interval);
      interval = setInterval(()=>{ if(!drawer || drawer.classList.contains('is-open')) readCartAndRender(banner); }, 2000);
    }
    loop();

    // Primera lectura
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded', ()=>readCartAndRender(banner), {once:true});
    }else{
      readCartAndRender(banner);
    }
  }

  function initAll(){ document.querySelectorAll('.'+CLS).forEach(initOne); }
  initAll();

  // Re-inicializa si el tema reemplaza HTML por AJAX
  const mo = new MutationObserver(() => initAll());
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();
